export enum InsightType {
  DAILY_ACTIVE_USERS = 'DAILY_ACTIVE_USERS',
  WEEKLY_ACTIVE_USERS = 'WEEKLY_ACTIVE_USERS',
  MONTHLY_ACTIVE_USERS = 'MONTHLY_ACTIVE_USERS',
  AVG_SESSION_DURATION = 'AVG_SESSION_DURATION',
  TOTAL_USERS = 'TOTAL_USERS',
  TOTAL_USERS_BREAKDOWN = 'TOTAL_USERS_BREAKDOWN',
  ACTIVE_USERS = 'ACTIVE_USERS',
  TOTAL_SESSIONS = 'TOTAL_SESSIONS',
  DAILY_SESSIONS = 'DAILY_SESSIONS',
  DAILY_SESSIONS_DURATION = 'DAILY_SESSIONS_DURATION',
  AVG_SESSION_DURATION_NUMBER = 'AVG_SESSION_DURATION_NUMBER',
  MODULES_FILTERS_ADOPTION = 'MODULES_FILTERS_ADOPTION',
  VIEWS_BY_MODULE = 'VIEWS_BY_MODULE',
  VIEWS_BY_SCREEN = 'VIEWS_BY_SCREEN',
  SCREEN_VIEWS = 'SCREEN_VIEWS',
  TOTAL_SCREEN_VIEWS = 'TOTAL_SCREEN_VIEWS',
  USER_BY_OS = 'USER_BY_OS',
  INSTALLS_BY_OS = 'INSTALLS_BY_OS',
  UNINSTALLS_BY_OS = 'UNINSTALLS_BY_OS',
  INSTALLS_BY_BANK = 'INSTALLS_BY_BANK',
  NEW_BANK_USERS_LAST_30_DAYS = 'NEW_BANK_USERS_LAST_30_DAYS',

  // events insights
  ACTIVE_EVENTS = 'ACTIVE_EVENTS',
  DRAFT_EVENTS = 'DRAFT_EVENTS',
  REVIEW_EVENTS = 'REVIEW_EVENTS',
  OVERDUE_EVENTS = 'OVERDUE_EVENTS',
  CANCELLED_EVENTS = 'CANCELLED_EVENTS',
  EVENTS_OPENS = 'EVENTS_OPENS',
  EVENTS_OPENS_BREAKDOWN = 'EVENTS_OPENS_BREAKDOWN',
  UPCOMING_VRSTAR_EVENTS = 'UPCOMING_VRSTAR_EVENTS',

  // news insights
  TOTAL_NEWS = 'TOTAL_NEWS',
  NEWS_OPEN = 'NEWS_OPEN',
  NEWS_OPENS_BREAKDOWN = 'NEWS_OPENS_BREAKDOWN',

  // partners insights
  PARTNERS_OPENS = 'PARTNERS_OPENS',
  PARTNERS_OPENS_BREAKDOWN = 'PARTNERS_OPENS_BREAKDOWN',
  BANK_PARTNERS_OPENS = 'BANK_PARTNERS_OPENS',
  BANK_PARTNERS_OPENS_BREAKDOWN = 'BANK_PARTNERS_OPENS_BREAKDOWN',
  ACTIVE_PARTNERS = 'ACTIVE_PARTNERS', // general partners, visible to everyone

  // bank offers insights
  ACTIVE_OFFERS = 'ACTIVE_OFFERS',
  DRAFT_OFFERS = 'DRAFT_OFFERS',
  REVIEW_OFFERS = 'REVIEW_OFFERS',
  OVERDUE_OFFERS = 'OVERDUE_OFFERS',
  OFFERS_OPENS = 'OFFERS_OPENS',
  OFFERS_OPENS_BREAKDOWN = 'OFFERS_OPENS_BREAKDOWN',

  // meinplus partners insights
  MEINPLUS_PARTNERS_OPENS = 'MEINPLUS_PARTNERS_OPENS',
  MEINPLUS_PARTNERS_OPENS_BREAKDOWN = 'MEINPLUS_PARTNERS_OPENS_BREAKDOWN',
  MEINPLUS_LOGINS = 'MEINPLUS_LOGINS',

  // senior care insights
  SENIOR_CARE_OPENS = 'SENIOR_CARE_OPENS',
  SENIOR_CARE_CTA_FUNNEL = 'SENIOR_CARE_CTA_FUNNEL',

  // real estate insights
  TOTAL_REAL_ESTATES = 'TOTAL_REAL_ESTATES',
  REAL_ESTATES_OPENS = 'REAL_ESTATES_OPENS',
  REAL_ESTATES_OPENS_BREAKDOWN = 'REAL_ESTATES_OPENS_BREAKDOWN',
  ESTATE_CONTACT_CTA = 'ESTATE_CONTACT_CTA',
  ESTATE_FINANCING_REQUEST_CTA_FROM_DETAIL_PAGE = 'ESTATE_FINANCING_REQUEST_CTA_FROM_DETAIL_PAGE',
  ESTATE_FINANCING_REQUEST_CTA_FROM_HOME_PAGE = 'ESTATE_FINANCING_REQUEST_CTA_FROM_HOME_PAGE',

  // resource total views
  RESOURCE_TOTAL_VIEWS = 'RESOURCE_TOTAL_VIEWS',
  RESOURCE_TOTAL_VIEWS_BY_TIME = 'RESOURCE_TOTAL_VIEWS_BY_TIME',
}

export enum ResourceStateType {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
  OVERDUE = 'OVERDUE',
  CANCELLED = 'CANCELLED',
  UPCOMING = 'UPCOMING',
}

export enum InsightIntervalType {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export enum PosthogInsightType {
  TREND = 'trend',
  FUNNEL = 'funnel',
}

export enum InsightChartType {
  ACTIONS_LINE_GRAPH = 'ActionsLineGraph',
  ACTIONS_LINE_GRAPH_CUMULATIVE = 'ActionsLineGraphCumulative',
  ACTIONS_BAR = 'ActionsBar',
  BOLD_NUMBER = 'BoldNumber',
  ACTIONS_PIE = 'ActionsPie',
  ACTIONS_TABLE = 'ActionsTable',
}
